import React from 'react'
import FormGenerator from 'Presentation/Components/Form/FormGenerator'
import { KTSVG } from '_metronic/helpers'

interface VariantItemProps {
	showImage: boolean
	disableDelete?: boolean
	onChange: (value: string) => void
}

const VariantItem: React.FC<VariantItemProps> = ({ showImage, disableDelete, onChange }) => {
	return (
		<div className="d-flex flex-row align-items-center w-100" style={{ gap: '8px' }}>
			{showImage && (
				<button className="btn btn-sm btn-light p-3">
					<KTSVG path="/media/icons/duotune/general/gen006.svg" className="svg-icon mx-auto" />
				</button>
			)}
			<div className="imageInputContainer">
				<label htmlFor="imageInput" className="iconLabel">
					<img src="/media/icons/kumopack/camera.svg" alt="Upload" className="icon" />
				</label>
				<input id="imageInput" type="file" className="fileInput" accept="image/*" />
			</div>
			<FormGenerator
				formKey="variantItemInput"
				inputType="plain"
				placeholder="ใส่ค่าที่ต้องการ"
				containerClassName="w-100"
				additionalClassName="form-control-sm"
				onChange={e => onChange(e.target.value)}
			/>
			{!disableDelete ? (
				<button className="btn btn-sm btn-light-danger p-3" disabled={disableDelete}>
					<KTSVG path="/media/icons/duotune/arrows/arr015.svg" className="svg-icon mx-auto" />
				</button>
			) : (
				<div style={{ width: showImage ? 43 : 40 }} />
			)}
		</div>
	)
}

export { VariantItem }
